import { Controller } from "@hotwired/stimulus"

// Scrolls to the form error box when the page loads with validation errors
export default class extends Controller {
  connect() {
    const errorBox = this.element.querySelector("[data-scroll-to-error]")
    if (errorBox) {
      errorBox.scrollIntoView({ behavior: "smooth", block: "start" })
    }
  }
}
